import { Section } from 'components/GridV2';
import OverflowCarousel from 'components/rebrand/OverflowCarousel';
import WhyUse from 'components/rebrand/WhyUse';

import { INewEnterprisePageSanityBenefit } from 'typescriptDefs/pages/enterprise';

interface Props {
  data: {
    firstBenefit: INewEnterprisePageSanityBenefit;
    secondBenefit: INewEnterprisePageSanityBenefit;
  };
}

const Benefits = ({ data }: Props) => {
  const whyData = data.secondBenefit.benefitContent.map((element) => ({
    description: element.content,
    heading: element.heading,
  }));
  return (
    <>
      <OverflowCarousel
        cards={data.firstBenefit.benefitContent}
        nextNavigationClass="enterprise-next"
        prevNavigationClass="enterprise-prev"
        heading={data.firstBenefit.heading}
      />
      <Section>
        <WhyUse headingClassname="md:w-[50%]" heading={data.secondBenefit.heading} uses={whyData} />
      </Section>
    </>
  );
};

export default Benefits;
